import React from "react";

const ServiceContent = [
  {
    icon: "icon-browser",
    title: "Desarrollo Web & E-Commerce",
    descriptions: `Diseño responsivo de alto impacto, tiendas en línea en Shopify/WooCommerce y optimización de conversión (CRO).`,
    delayAnimation: "",
  },
  {
    icon: "icon-cloud",
    title: "Infraestructura Cloud",
    descriptions: `Migración a Google Cloud, Hosting de alta disponibilidad y despliegue de servidores escalables.`,
    delayAnimation: "200",
  },
  {
    icon: "icon-envelope",
    title: "Google Workspace",
    descriptions: `Implementación de correo corporativo, herramientas colaborativas y seguridad en la nube.`,
    delayAnimation: "400",
  },
  {
    icon: "icon-tools",
    title: "Soporte Técnico & Consultoría",
    descriptions: `Resolución de incidencias (+200 tickets atendidos) y mantenimiento preventivo de infraestructura.`,
    delayAnimation: "600",
  },
  {
    icon: "icon-shield",
    title: "Propiedad Intelectual",
    descriptions: `Gestión técnica y trámites digitales para el Registro de Marca ante el IMPI.`,
    delayAnimation: "800",
  },
];
export default function Service() {
  return (
    <>
      <div className="row justify-content-center">
        {ServiceContent.map((val, i) => (
          <div
            className="col-md-6 col-lg-4 my-3"
            key={i}
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-delay={val.delayAnimation}
          >
            <div className="feature-box-01">
              <div className="icon">
                <i className={`icon ${val.icon}`}></i>
              </div>
              <div className="feature-content">
                <h3 className="h5">{val.title}</h3>
                <p>{val.descriptions}</p>
              </div>
            </div>
            {/* End .feature-box-01 */}
          </div>
        ))}
      </div>
    </>
  );
}
